/* global gdAlertify */
import React, { useState, useEffect } from 'react';
import axiosInstance from "../config/axiosConfig";
import { formatDate } from "../utils/utils";
import { NavLink, useNavigate } from 'react-router-dom';
import GdTable from './components/GdTable';

const SolicitudesReemplazo = () => {
    const navigate = useNavigate();
    const [solicitudes, setSolicitudes] = useState([]);
    const [mostrarTodas, setMostrarTodas] = useState(false);

    // 🔹 Obtener solicitudes desde el backend
    async function fetchSolicitudes() {
        try {
            const response = await axiosInstance.post("/reemplazos/solicitud/lista", {
                todas: mostrarTodas ? 1 : 0
            });

            if (response.data.error) {
                setSolicitudes([]);
            } else {
                setSolicitudes(response.data.data || []);
            }
        } catch (error) {
            console.error("Error al obtener los datos: ", error);
        }
    }

    // 🔹 Llamar API al cargar o cambiar el checkbox
    useEffect(() => {
        fetchSolicitudes();
    }, [mostrarTodas]);

    // 🔹 Eliminar solicitud
    const eliminar = (id) => {
        gdAlertify.confirm({
            title: 'Eliminar Solicitud de reemplazo',
            message: '¿Está seguro de que desea eliminar esta Solicitud de reemplazo?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post('/reemplazos/solicitud/eliminar', { id });
                    if (!response.data.error) {
                        gdAlertify.notify('Solicitud de reemplazo eliminada correctamente', 'success');
                        fetchSolicitudes();
                    } else {
                        gdAlertify.notify(response.data.message || 'Error al eliminar la solicitud', 'error');
                    }
                } catch (error) {
                    gdAlertify.notify('Error al eliminar la solicitud', 'error');
                }
            },
            onCancel: () => gdAlertify.notify('Acción cancelada', 'info')
        });
    };

    // 🔹 Definir columnas de la tabla
    const columns = [
        { name: 'id', title: 'Solicitud', width: 50 },
        { name: 'nombrePaciente', title: 'Paciente', width: 200 },
        { name: 'nombreAuxiliar', title: 'Auxiliar', width: 200 },
        { name: 'fechaInicio', title: 'Fecha Inicio', render: row => formatDate(row.fechaInicio), width: 100 },
        { name: 'fechaFin', title: 'Fecha Fin', render: row => formatDate(row.fechaFin), width: 100 },
        { name: 'desTurno', title: 'Turno', width: 100 },
        {
            name: 'estado',
            title: 'Estado',
            render: (row) => row.estado == 1 ? 'Terminada' : 'Pendiente',
            width: 100
        },
        {
            name: 'acciones',
            title: 'Acción',
            render: (row) => {
                return (
                    <div className="d-flex gap-2">
                        {row.estado != 1 && (
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => navigate('/ingreso-reemplazos/' + row.id)}>
                                Resolver
                            </button>
                        )}
                        {row.estado != 1 && (
                            <button
                                className="btn btn-info btn-sm text-white"
                                onClick={() => navigate('/new-ingreso-reemplazos/' + row.id)}>
                                Resolver 2
                            </button>
                        )}
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminar(row.id)}>
                            Eliminar
                        </button>
                    </div>
                );
            },
            width: 200
        }
    ];

    // 🔹 Render principal
    return (
        <div className="container mt-5">
            <div className="card p-4">
                <div className="mb-3 row align-items-center">
                    <div className="col-md-3 d-flex gap-2">
                        <NavLink to="/solicitud-reemplazo" className="dropdown-item w-auto">
                            <button className="btn btn-primary w-100">Crear</button>
                        </NavLink>
                        <NavLink to="/new-solicitud-reemplazo" className="dropdown-item w-auto">
                            <button className="btn btn-info text-white w-100">Crear v2</button>
                        </NavLink>
                    </div>

                    <div className="col-md-4 form-check ms-3">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="mostrarTodas"
                            checked={mostrarTodas}
                            onChange={(e) => setMostrarTodas(e.target.checked)}
                        />
                        <label className="form-check-label ms-2" htmlFor="mostrarTodas">
                            Mostrar todas las solicitudes
                        </label>
                    </div>
                </div>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <GdTable
                            columns={columns}
                            data={solicitudes}
                            defaultItemsPerPage={100}
                            itemsPerPageOptions={[5, 10, 25, 50, 100]}
                            // 🔹 Orden dinámico según checkbox
                            initialSort={[3, mostrarTodas ? "desc" : "asc"]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SolicitudesReemplazo;
